import { Outlet, useNavigate } from "react-router-dom"
import { useCurrentUserMaybe } from "../auth/CurrentUserContext"
import { useEffect } from "react"
import { useHomePath } from "~/common/useHomePath"

export const RequireUserSignedOut = () => {
  const navigate = useNavigate()
  const { currentUser } = useCurrentUserMaybe()
  const homePath = useHomePath()

  useEffect(() => {
    if (currentUser) {
      navigate(homePath)
    }
  }, [currentUser, navigate, homePath])

  return <Outlet />
}
